import { render } from "./ConsultantToolsSpotlight.vue?vue&type=template&id=1c43c7be"
import script from "./ConsultantToolsSpotlight.vue?vue&type=script&lang=js"
export * from "./ConsultantToolsSpotlight.vue?vue&type=script&lang=js"

import "./ConsultantToolsSpotlight.vue?vue&type=style&index=0&id=1c43c7be&lang=scss"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__